<template>
  <div class="navbar">
    <div class="logo">
      <div class="jump" @click="toIndex()">
        <img style="height: 30px" src="../assets/logoNew.png" />
      </div>
      <div
        class="typePick"
        v-if="
          (!$route.query.token ||
            $route.query.channelId !== undefined ||
            $route.query.postJump == 1) &&
          showBtn
        "
      >
        <el-dropdown trigger="click" @command="typePickFn">
          <span class="el-dropdown-link">
            <span>发布{{ showText }}</span>
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in typeOption"
              :key="index"
              :command="item.type"
              style="
                display: flex;
                align-items: center;
                padding-left: 17px;
                padding-right: 35px;
              "
            >
              <img
                :src="item.icon"
                class="typeIcon"
                style="height: 20px; margin-right: 9px"
              />
              <p
                class="typeIcon"
                style="
                  color: #333333;
                  font-family: 'PingFang SC';
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                "
              >
                {{ item.name }}
              </p>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <BanDialog
      ref="banShow"
      :isShow="isBanned"
      :allowClose="true"
      @closeBan="isBanned = false"
    ></BanDialog>
  </div>
</template>

<script>
import BanDialog from "../components/banDialog.vue";

export default {
  name: "NavBar",
  data() {
    return {
      typeOption: [
        {
          type: 1,
          name: "文章",
          icon: require("../assets/script/type1.png"),
        },
        {
          type: 2,
          name: "视频",
          icon: require("../assets/script/type2.png"),
        },
        {
          type: 3,
          name: "图集",
          icon: require("../assets/script/type3.png"),
        },
        {
          type: 6,
          name: "帖子",
          icon: require("../assets/script/type4.png"),
        },
      ],
      typeNow: 1,
      tokenQuery: {},
      isBanned: false,
      showText: "",
    };
  },
  components: {
    BanDialog,
  },
  created() {
    this.typeNow = this.type;
    this.tokenQuery = JSON.parse(JSON.stringify(this.$route.query));
    if (this.type == 6) {
      this.showText = this.typeOption[3].name;
    } else {
      this.showText = this.typeOption[this.type - 1].name;
    }
  },
  props: {
    type: {
      type: Number,
      default: () => 1,
    },
    showBtn: {
      type: Boolean,
      default: () => true,
    },
  },
  methods: {
    toIndex() {
      if (
        !this.$route.query.token ||
        this.$route.query.channelId !== undefined ||
        this.$route.query.postJump == 1
      ) {
        this.$router.push({ path: "/index", query: {} });
      }
    },
    isEmptyObject(obj) {
      delete obj.token;
      for (var key in obj) {
        return false;
      }
      return true;
    },
    typePickFn(index) {
      this.typeNow = index;

      if (this.typeNow != this.type) {
        let path = "";
        switch (this.typeNow) {
          case 1:
            path = "/scriptWrite";
            break;
          case 2:
            path = "/videoWrite";
            break;
          case 3:
            path = "/graphWrite";
            break;
          case 6:
            path = "/post";
            break;
        }

        if (localStorage.getItem("banData")) {
          let banData = JSON.parse(localStorage.getItem("banData"));
          if (
            (this.typeNow == 6 &&
              banData.ban_type == 1 &&
              banData.ban_range_type.indexOf("3") > -1) ||
            (this.typeNow != 6 &&
              banData.ban_type == 1 &&
              banData.ban_range_type.indexOf("1") > -1)
          ) {
            this.$refs.banShow.getReason(localStorage.getItem("token"));
            this.isBanned = true;
            return;
          }
        }

        if (
          this.isEmptyObject(this.$route.query) ||
          this.$route.query.channelId !== undefined
        ) {
          let thisQuery = this.$route.query;
          if (window.location.href.split("token=")[1]) {
            thisQuery.token = window.location.href
              .split("token=")[1]
              .replace("%3A", ":");
          }
          this.$router.push({ path: path, query: thisQuery });

          if (this.type == 6) {
            this.showText = this.typeOption[3].name;
          } else {
            this.showText = this.typeOption[this.type - 1].name;
          }
        } else {
          let routeData = this.$router.resolve({
            path: path,
            query: {},
          });
          window.open(routeData.href, "_blank");

          this.typeNow = this.type;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 60px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  width: 100%;
  box-sizing: border-box;

  .logo {
    padding-left: 48px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    line-height: 84px;
    background: #fff;
    color: #002140;

    .jump {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .typePick {
      height: 32px;
      display: flex;
      align-items: center;
      margin-left: 20px;
      color: #333333;
      font-family: "PingFang SC";
      font-size: 18px;
      font-weight: 500;
      line-height: 25px;
      padding-left: 20px;
      border-left: 2px solid #edf1f8;
      cursor: pointer;

      span {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 16px;
        font-style: normal;
        font-weight: bold;
      }
    }
  }
}
</style>
